import { WorkflowDefinition } from '~/redux/api/types/k2/workflows';

export const MOCK_WORKFLOW_DEFINITION: WorkflowDefinition = {
  name: 'Conditional Task Workflow - Lara',
  intake_form_id: null,
  stages: [
    {
      id: 'stage-triage',
      name: 'Triage',
      tasks: [
        {
          id: 'task-standard-review',
          name: 'Standard Review',
          type: 'review',
          tasks: [],
          actors: [
            {
              actor_id: 'user-1',
              actor_type: 'User',
              actions_taken: [],
              user_expression: {},
            },
          ],
          allowed_actions: [
            { id: 'approve', label: 'Approve', intent: 'positive' },
            { id: 'reject', label: 'Reject', intent: 'negative' },
          ],
          depends_on: [],
          description: 'Always visible standard review task',
          done_condition: null,
          system_actions: [],
          visible_condition: null,
          required_approvals: 1,
          assignment_mode: 'specific_user',
        },
        {
          id: 'task-priority-escalation',
          name: 'Priority Escalation',
          type: 'review',
          tasks: [],
          actors: [
            {
              actor_id: 'user-1',
              actor_type: 'User',
              actions_taken: [],
              user_expression: {},
            },
          ],
          allowed_actions: [
            { id: 'complete', label: 'Complete', intent: 'positive' },
          ],
          depends_on: [],
          description: 'Only visible when priority is high',
          done_condition: null,
          system_actions: [],
          visible_condition: { condition_id: 'cond-high-priority' },
          required_approvals: 1,
          assignment_mode: 'specific_user',
        },
        {
          id: 'task-is-international',
          name: 'International contract',
          type: 'review',
          tasks: [],
          actors: [
            {
              actor_id: 'user-1',
              actor_type: 'User',
              actions_taken: [],
              user_expression: {},
            },
          ],
          allowed_actions: [
            { id: 'complete', label: 'Complete', intent: 'positive' },
          ],
          depends_on: [],
          description:
            'Only visible when the ticket name implies an international contract',
          done_condition: null,
          system_actions: [],
          visible_condition: { condition_id: 'cond-is-international' },
          required_approvals: 1,
          assignment_mode: 'specific_user',
        },
      ],
      description: '',
      exit_actions: [],
      entry_actions: [],
      back_out_actions: [],
      visible_condition: null,
    },
    {
      id: 'stage-complete',
      name: 'Complete',
      tasks: [
        {
          id: 's1-task-a',
          name: 'Document Collection',
          type: 'review',
          tasks: [],
          actors: [
            {
              actor_id: 'user-1',
              actor_type: 'User',
              actions_taken: [],
              user_expression: {},
            },
          ],
          allowed_actions: [
            { id: 'approve', label: 'Approve', intent: 'positive' },
            { id: 'reject', label: 'Reject', intent: 'negative' },
          ],
          depends_on: [],
          description: '',
          done_condition: null,
          system_actions: [],
          visible_condition: null,
          required_approvals: 1,
          assignment_mode: 'specific_user',
        },
        {
          id: 's1-task-b',
          name: 'Preliminary Review',
          type: 'review',
          tasks: [],
          actors: [
            {
              actor_id: 'user-1',
              actor_type: 'User',
              actions_taken: [],
              user_expression: {},
            },
          ],
          allowed_actions: [
            { id: 'approve', label: 'Approve', intent: 'positive' },
            { id: 'reject', label: 'Reject', intent: 'negative' },
          ],
          depends_on: ['s1-task-a'],
          description: '',
          done_condition: null,
          system_actions: [],
          visible_condition: null,
          required_approvals: 1,
          assignment_mode: 'specific_user',
        },
        {
          id: 's1-task-c',
          name: 'Risk Assessment',
          type: 'review',
          tasks: [],
          actors: [
            {
              actor_id: 'user-1',
              actor_type: 'User',
              actions_taken: [],
              user_expression: {},
            },
          ],
          allowed_actions: [
            { id: 'approve', label: 'Approve', intent: 'positive' },
            { id: 'reject', label: 'Reject', intent: 'negative' },
          ],
          depends_on: ['s1-task-a'],
          description: '',
          done_condition: null,
          system_actions: [],
          visible_condition: null,
          required_approvals: 1,
          assignment_mode: 'specific_user',
        },
        {
          id: 's1-task-d',
          name: 'Complete',
          type: 'review',
          tasks: [],
          actors: [
            {
              actor_id: 'user-1',
              actor_type: 'User',
              actions_taken: [],
              user_expression: {},
            },
          ],
          allowed_actions: [
            { id: 'complete', label: 'Complete', intent: 'positive' },
          ],
          depends_on: ['s1-task-b', 's1-task-c'],
          description: '',
          done_condition: null,
          system_actions: [],
          visible_condition: null,
          required_approvals: 1,
          assignment_mode: 'specific_user',
        },
      ],
      description: '',
      exit_actions: [],
      entry_actions: [],
      back_out_actions: [],
      visible_condition: null,
    },
  ],
  parties: [],
  settings: { acl: [], accepted_file_types: [] },
  documents: [],
  description:
    'This workflow has conditions setup to show certain tasks, and displays both sequential and parallel tasks',
  form_library: [
    {
      id: 'intake-form',
      name: 'Intake Form',
      sections: [
        {
          id: 'section-1',
          name: 'Contract Details',
          questions: [
            {
              id: 'q1',
              name: 'Contract Name',
              form_field: { field_id: 'local-1-contract-name' },
              description: 'Name of the contract',
              is_required: true,
              is_read_only: false,
            },
            {
              id: 'q2',
              name: 'Contract Value',
              form_field: { field_id: 'local-2-contract-value' },
              description: 'Total contract value',
              is_required: false,
              is_read_only: false,
            },
            {
              id: 'q3',
              name: 'Ticket Priority',
              form_field: { field_id: 'local-3-ticket-priority' },
              description: 'Priority of the ticket',
              is_required: false,
              is_read_only: false,
            },
          ],
          description: 'Basic contract information',
        },
      ],
      description: 'Collect initial information',
      document_ids: [],
    },
  ],
  field_library: [
    {
      id: 'local-1-contract-name',
      name: 'Contract Name',
      data_type: 'string',
      description: 'Name of the contract',
    },
    {
      id: 'local-2-contract-value',
      name: 'Contract Value',
      data_type: 'number',
      description: 'Total contract value',
    },
    {
      id: 'local-3-ticket-priority',
      name: 'Priority',
      data_type: 'string',
      description: 'The priority level of the ticket',
    },
  ],
  action_library: [],
  condition_library: [
    {
      id: 'cond-high-priority',
      name: 'High Priority Condition',
      expression: {
        expression_id: 'expr-high-priority',
        expression_params: [],
        is_local_expression: true,
      },
      description: 'Task is visible only when priority is high',
    },
    {
      id: 'cond-is-international',
      name: 'International contract Condition',
      expression: {
        expression_id: 'expr-is-international',
        expression_params: [],
        is_local_expression: true,
      },
      description: 'Task is visible only when the contract is International',
    },
  ],
  expression_library: [
    {
      id: 'expr-high-priority',
      name: 'Is High Priority',
      expression:
        '{"type":"equals","operands":[{"type":"param","value":"ticket.field_values.local-3-ticket-priority"},{"type":"literal","value":"high"}]}',
      description: "Check if priority field equals 'high'",
      result_type: 'boolean',
      expression_params: [
        {
          name: 'ticket.field_values.local-3-ticket-priority',
          type: 'string',
          value: null,
        },
      ],
    },
    {
      id: 'expr-is-international',
      name: 'Is International',
      expression:
        '{"type":"contains","operands":[{"type":"param","value":"ticket.name"},{"type":"literal","value":"[international]"}]}',
      description: "Check if the ticket name contains '[international]'",
      result_type: 'boolean',
      expression_params: [{ name: 'ticket.name', type: 'string', value: null }],
    },
  ],
  doc_template_library: [],
};
